<template>
  <div :key="idCourse">
    <div v-if="courseData" class="d-flex align-items-center justify-content-between mb-3">
      <div class="d-flex align-items-center">
        <h2 class="mr-3">{{courseData.name}}</h2>
        <!-- <a-tag :color="courseData.statusPublication === 'published' ? 'green' : 'orange'">{{courseData.statusPublication === 'published' ? 'TERPUBLIKASI': 'DRAF'}}</a-tag> -->
      </div>
      <div v-if="store.state.user.role === 'admin'">
        <a-button @click.prevent="deleteCourse" type="danger">
          <delete-outlined></delete-outlined>
          Hapus Potensi</a-button>
      </div>
    </div>
    <a-card>
      <div>
        <a-row class="mt-4" :gutter="[32,0]">
          <a-col :md="24">
            <div class="text-center">
              <a-radio-group class="mb-3" v-model:value="activeMenu" button-style="solid">
                <a-radio-button value="general">Informasi Umum</a-radio-button>
                <a-radio-button value="gisMenu">Peta GIS</a-radio-button>
                <!-- <a-radio-button value="banner">Banner</a-radio-button> -->
                <!-- <a-radio-button value="discountedPrice">Harga Diskon</a-radio-button> -->
              </a-radio-group>
            </div>
            <template v-if="activeMenu === 'general'">
              <general-menu :potensi="dataPotensi" @fetch="fetchDetail" :vendors="vendors" :categories="categories">
              </general-menu>
            </template>
            <template v-else-if="activeMenu === 'gisMenu'">
              <section-lesson-menu :course="courseData" @fetchCourse="fetchCourse">
              </section-lesson-menu>
            </template>
            <template v-else-if="activeMenu === 'banner'">
              <banner-menu :course="courseData" :banner="bannerData" @fetchCourse="fetchCourse" @fetchBanner="fetchBanner"></banner-menu>
            </template>
            <template v-else-if="activeMenu === 'discountedPrice'">
              <discounted-price-menu :course="courseData" @fetchCourse="fetchCourse" :discounted-price-list="discountedPriceList" @fetchDiscountedCourse="fetchDiscountedCourse"></discounted-price-menu>
            </template>
          </a-col>
          <!-- <a-col :md="24" :lg="8" v-if="showUpload" class="d-flex justify-content-between">
            <a-divider class="h-100" type="vertical"></a-divider>
            <div class="w-100 th-upload-wrapper">
              <a-upload
                accept="image/jpeg,image/png"
                v-model:file-list="fileList"
                name="thumbnail"
                :action="`${backendUrl}api/course/upload-thumbnail/${idCourse}`"
                list-type="picture-card"
                :show-upload-list="false"
                :headers="{
                  authorization: 'authorization-text',
                }"
                :custom-request="customRequestUpload"
              >
                <div v-if="courseData.thumbnailSmall" class="w-100 text-center">
                  <img width="300" height="100" :src="`${backendUrl}${courseData.thumbnailSmall}`" alt="course" />
                </div>
                <div v-else>
                  <loading-outlined v-if="loading"></loading-outlined>
                  <plus-outlined v-else></plus-outlined>
                  <div class="ant-upload-text">Upload Thumbnail</div>
                </div>
              </a-upload>
              <div v-if="courseData.thumbnailSmall" class="text-center">
                <a-button @click.prevent="deleteBannerCourse" class="text-danger" type="link">
                  <delete-outlined></delete-outlined>
                  Hapus Banner Course</a-button>
              </div>
              <div>
                Keterangan:
                <ul>
                  <li>Thumbnail harus berformat JPG/PNG</li>
                  <li>Thumbnail harus memiliki rasio gambar sebesar 3:1</li>
                  <li>Thumbnail minimal berukuran 750x250</li>
                </ul>
              </div>
            </div>
          </a-col> -->
        </a-row>
      </div>
    </a-card>
    <a-card class="mt-2" v-if="store.state.user.role === 'admin'">
      <h4 class="mb-2"> Tabel Alamat Alternatif </h4>
      <a-table class="mt-5" :columns="columns" :data-source="filteredData" bordered :loading="loadingTable">
        <template #action="{text, record}">
          <a-popconfirm @confirm="() => checkActive(record._id)" title="Buat data aktif?">
            <a>
              <i class="fe fe-square" style="font-size: 26px;" />
            </a>
          </a-popconfirm>
            {{text}}
          </template>
          <template #name="{ text }">
              {{text}}
          </template>
          <template #description="{ text, record }">
            <span>
              {{text }}
              <br>{{record.province}} {{record.city}}
              <br><strong> {{ record.address === 'ALAMAT TIDAK DITEMUKAN' ? '' : record.closestKC.name}}</strong>
            </span>
          </template>
          <template #status="{ text }">
            <a-tag :color="text === 'published' ? 'green' : 'orange'">
              {{ text === 'published' ? 'Terpublikasi' : '&nbsp;Terduplikat&nbsp;' }}
            </a-tag>
          </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { onMounted, ref, createVNode, computed } from 'vue'
import { defineAsyncComponent } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { PlusOutlined, LoadingOutlined, DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { message, Modal, notification } from 'ant-design-vue';
import { getOne, remove, getAllPendings, update } from '@/services/axios/brivice-backend'
import apiClient from '@/services/axios'

const columns = [
  {
    title: 'Nama',
    dataIndex: 'name',
    key: 'name',
    slots: { customRender: 'name' },
    width: '15%',
  },
  {
    title: 'Alamat',
    dataIndex: 'address',
    key: 'description',
    slots: { customRender: 'description' },
  },
  {
    title: 'Telepon',
    dataIndex: 'phone',
    key: 'vendor',
    slots: { customRender: 'vendor' },
    align: 'center',
    width: '15%',
  },
  {
    title: 'Induk Perusahaan',
    dataIndex: 'indukPerusahaan',
    key: 'indukPerusahaan',
    slots: { customRender: 'indukPerusahaan' },
    align: 'center',
    width: '15%',
  },
  {
    title: 'Buat Aktif',
    dataIndex: 'action',
    key: 'action',
    slots: { customRender: 'action' },
    align: 'center',
  },
];

const GeneralMenu = defineAsyncComponent(() => import('@/components/Course/General'))
const SectionLessonMenu = defineAsyncComponent(() => import('@/components/Course/SectionLesson'))
const BannerMenu = defineAsyncComponent(() => import('@/components/Course/Banner'))
const DiscountedPriceMenu = defineAsyncComponent(() => import('@/components/Course/DiscountedPrice'))

function getBase64(img) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => resolve(reader.result));
    reader.addEventListener('error', (err) => reject(err));
    reader.readAsDataURL(img);
  })
}
export default {
  components: { GeneralMenu, SectionLessonMenu, BannerMenu, DiscountedPriceMenu, DeleteOutlined },
  setup() {
    let store = useStore()
    let courseData = ref({})
    let route = useRoute()
    const dataPotensi = ref([])
    const router = useRouter()
    const fileList = ref([])
    const activeMenu = ref('general')
    let filteredData = ref([])
    let loadingTable = ref(false)
    const loading = ref(false);
    const imageUrl = ref('');
    const idCourse = route.params.id
    const bannerData = ref({})

    const fetchAllPendings = async (name) => {
      loadingTable.value = true
      const potensiList = await getAllPendings(name)
      // const kanwils = await getAllKanwil()
      // kanwilData.value = kanwils.result
      filteredData.value = potensiList.result.filter(d => d.status === 'pending')
      loadingTable.value = false
    }

    const checkActive = async (id) => {
      try {
        const acc_token = localStorage.getItem('access_token')
        const payload = { _id: id, status: 'active', accesstoken: acc_token }
        const data = await update(payload)
        payload._id = dataPotensi.value._id
        payload.status = 'pending'
        const oldData = await update(payload)
        notification.success({
          message: `Berhasil Mengubah Data Potensi`,
        })
        router.push('/potensi')
        // fetchCourse()
      } catch (err) {
        console.log(err)
        notification.error({
          message: 'Gagal mengubah data potensi',
        })
      }
    }

    const handleChange = info => {
      if (info.file.status === 'uploading') {
        loading.value = true;
        return;
      }

      if (info.file.status === 'done') {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, base64Url => {
          imageUrl.value = base64Url;
          loading.value = false;
        });
        message.success('Upload berhasil.');
        fetchCourse()
      }

      if (info.file.status === 'error') {
        loading.value = false;
        message.error('upload error');
      }
    }

    const beforeUpload = async file => {
      try {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        imageUrl.value = await getBase64(file)
        if (!isJpgOrPng) {
          message.error('Anda hanya dapat mengunggah file JPG/PNG');
        }


        const loadImage = (url) => new Promise((resolve, reject) => {
          const img = new Image()
          img.addEventListener('load', () => resolve(img));
          img.addEventListener('error', (err) => reject(err));
          img.src = url
          // console.log(img)
        })

        const img = await loadImage(imageUrl.value)
        const dimension = {
          width: img.width,
          height: img.height,
        }


        const isRatioFit = Math.round(dimension.width / dimension.height) == 3
        if (!isRatioFit) {
          message.error('Anda hanya dapat mengunggah file dengan rasio gambar 3:1');
        }

        const isWidthFit = dimension.width >= 750 || dimension.height >= 250
        if (!isWidthFit) {
          message.error('Anda hanya dapat mengunggah file dengan ukuran minimal 750x250');
        }

        // const isLt2M = file.size / 1024 / 1024 < 2;

        // if (!isLt2M) {
        //   message.error('Image must smaller than 2MB!');
        // }

        // return isJpgOrPng && isLt2M;
        console.log(isJpgOrPng && isWidthFit && isRatioFit, 'masuk sini')
        return isJpgOrPng && isWidthFit && isRatioFit;
      } catch(err) {
        console.log(err)
      }
    };

    onMounted(async () => {
      // fetchCourse()
      // fetchVendors()
      // fetchCategories()
      // fetchBanner()
      fetchDetail()
      // fetchDiscountedCourse()
    })

    const discountedPriceList = ref([])
    const fetchDiscountedCourse = async () => {
      // const rawData = await store.dispatch('discountedCourse/FETCH_DISCOUNTED_COURSE_BY_ID_COURSE', { idCourse })
      // // console.log(rawData)
      // discountedPriceList.value = rawData.map(discountData => {
      //   return {
      //     ...discountData,
      //     key: discountData._id,
      //   }
      // })
    }

    const vendors = ref([])
    const categories = ref([])

    const fetchVendors = async () => {
      // const rawData = await store.dispatch('vendor/FETCH_VENDOR')
      // vendors.value = rawData.map(vendor => {
      //   return {
      //     name: vendor.firstName + (vendor.lastName ? ' ' + vendor.lastName : ''),
      //     ...vendor,
      //   }
      // })
    }
    
    const fetchDetail = async () => {
      const data = await getOne(route.params.id)
      dataPotensi.value = data.result
      fetchAllPendings(data.result.queryName)
      console.log(dataPotensi.value, 'detail')
      return data.result
    }

    const fetchCategories = async () => {
      // categories.value = await store.dispatch('category/FETCH_CATEGORY')
    }

    const fetchCourse = async () => {
      // courseData.value = await store.dispatch('course/FETCH_COURSE_BY_ID', {
      //   id: route.params.id,
      // })
    }

    const fetchBanner = async () => {
      // const res = await store.dispatch('banner/FETCH_BANNER_BY_COURSE', {
      //   idCourse: route.params.id,
      // })

      // bannerData.value = res || {}
    }

    const customRequestUpload = async (data) => {
      try {
        const isPassed = await beforeUpload(data.file)
        console.log(isPassed, 'isPassed Uplaod')
        if (!isPassed)  {
          return ''
        } else {
          if (data.file.status !== 'uploading') {
          }
          const formData = new FormData()
          formData.append(data.filename, data.file)
          const { data: { data:res } } = await apiClient.post(data.action, formData, {
            ...data.headers,
          })

          message.success(`file ${data.file.name} berhasil diunggah.`);
        }
        fetchCourse()
        fetchBanner()
      } catch (err) {
        message.error(`file ${data.file.name} gagal diunggah.`);
        fetchCourse()
        fetchBanner()
        console.log(err)
      }
    }

    const deleteCourse = () => {
      Modal.confirm({
          title: `Apa anda yakin ingin menghapus Potensi ${dataPotensi.value.name}?`,
          icon: createVNode(ExclamationCircleOutlined),
          async onOk() {
            try {
              await remove(route.params.id)
              // await store.dispatch('course/DELETE_COURSE', { idCourse })
              router.push({ name: 'Course' })
              notification.success({
                message: `Berhasil Menghapus Potensi ${dataPotensi.value.name}.`,
              })
            } catch (err) {
              notification.error({
                message: `Gagal Menghapus Potensi ${dataPotensi.value.name}.`,
              })
              console.log(err)
            }
          },
          onCancel() {},
        })
    }

    const showUpload = computed(() => {
      return activeMenu.value === 'general' || activeMenu.value === 'sectionLesson' || (activeMenu.value === 'discountedPrice' && courseData.value.type === 'free')
    })

    const deleteBannerCourse = () => {
      Modal.confirm({
          title: `Apa anda yakin ingin menghapus banner ${courseData.value.name}?`,
          icon: createVNode(ExclamationCircleOutlined),
          async onOk() {
            try {
              await store.dispatch('course/DELETE_COURSE_BANNER', { idCourse })
              fetchCourse()
              fetchBanner()
              notification.success({
                message: `Berhasil Menghapus Banner ${courseData.value.name}.`,
              })
            } catch (err) {
              fetchCourse()
              fetchBanner()
              notification.error({
                message: `Gagal Menghapus Banner ${courseData.value.name}.`,
              })
              console.log(err)
            }
          },
          onCancel() {},
        })
    }

    return {
      courseData,
      activeMenu,
      fileList,
      imageUrl,
      handleChange,
      beforeUpload,
      loading,
      fetchCourse,
      store,
      idCourse,
      backendUrl: process.env.VUE_APP_BACKEND_URL,
      vendors,
      categories,
      fetchBanner,
      filteredData,
      fetchDetail,
      bannerData,
      fetchDiscountedCourse,
      loadingTable,
      checkActive,
      discountedPriceList,
      columns,
      customRequestUpload,
      deleteCourse,
      showUpload,
      deleteBannerCourse,
    }
  },
}
</script>
<style lang="scss">
.th-upload-wrapper {
  .ant-upload-picture-card-wrapper {
    display: flex;
    justify-content: center;
    .ant-upload {
      width: 300px;
      height: 100px;
    }
  }
}
</style>
